import React from 'react';
import { StyleSheet } from 'react-native';
import { theme, useResponsive, VStack } from '@sweetgreen/garnish';

import type { Credit } from '../../../graphql/types';
import { CreditOverviewBalance } from './CreditOverviewBalance';
import { CreditOverviewPromoCodeForm } from './CreditOverviewPromoCodeForm';

export const CreditOverview = (props: CreditOverviewProps) => {
  const { currentBreakpoint } = useResponsive();

  return (
    <VStack
      customSpacing={0}
      divider={currentBreakpoint.isXS}
      dividerColor={theme.colors.LIGHT}
      style={!currentBreakpoint.isXS && styles.container}
    >
      <CreditOverviewBalance {...props} />
      <CreditOverviewPromoCodeForm {...props} />
    </VStack>
  );
};

export type CreditOverviewProps = {
  readonly creditAmount: number;
  readonly creditDetails: readonly Credit[];
  readonly hasPromoCodeError: boolean;
  readonly promoCode: string;
  readonly isLoadingCredits?: boolean;
  readonly isLoadingSubmitPromoCodeResponse?: boolean;
  readonly onPressAddPromoCode: () => void;
  readonly onPressApplyPromoCode: (code: string) => void;
  readonly setPromoCode: (code: string) => void;
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'stretch',
    justifyContent: 'center',
  },
});
